<template>
    <section class="contenedor">
        <div class="pueba">

            <div class="kt-portlet__head-label" style="margin-top: 1rem;">
                <h3 class="kt-portlet__head-title text-center">
                    <b>Nos contactamos contigo</b>
                </h3>
                <h5 class="kt-portlet__head-title text-center">
                    No encontramos la placa de tu vehículo en nuestras bases de datos. Por favor, deje sus datos y nosotros nos comunicaremos lo antes
                    posible
                </h5>
            </div>
            
            <formulario-registro 
            @input="ObtenerFormulario" :titulo="''"
            @docInval = "ObtenerDocInval"/>
            
            <div class="espacioBotones">
                
                <div>
                    <button
                        style="width: 150px"
                        type="button" 
                        class="btn btn-primary btn-font-sm" 
                        v-on:click="atras">
                        Regresar
                    </button>
                </div>
                
                <div>
                    <button
                        style="width: 150px"
                        type="button" 
                        class="btn btn-primary btn-font-sm" 
                        v-on:click="siguiente"
                        :disabled="!form || loading || !this.formularioValido"
                        :class="{ 'cursor-not-allowed': !form || loading || !this.formularioValido}">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                        </span>
                        <span v-else>Enviar a un asesor</span>
                    </button>
                </div>
                        
            </div>
       
            
        </div>
    </section>
</template>

<script>
import formularioRegistro from '../../componentes/formulario-registro.vue';
import * as servicios from "../../servicios";

export default {
    components: { formularioRegistro },

    nombre: "PlacaNoEncontrada",

    props: ['formulario', 'docInval'],


    data: () => ({form: null, loading: false, formularioValido: false}),

    watch: {
        docInval: {
            immediate: true,
            handler(val, oldVal) {
                //console.log("->LLEWO", val)
            }

        },

    },

    methods: {
        siguiente: function () {
            this.loading = true;
            servicios.integracionFormulario.registroFormualrio(this.form,  process.env.VUE_APP_PREPAGADOS_PROSPECCION).then(res => {
                this.loading = false;
                this.$router.push({
                    name: "p4",
                    params: {
                        titulo: this.$route.params.titulo,
                        id: this.$route.params.id,
                    },
                });
            }).catch((error) => {
                this.loading = false;
            });
        },

        atras: function () {
            this.$router.push({ name: 'p1' })
        },

        ObtenerFormulario(newFormulario) {
            this.form = newFormulario;
        },

        ObtenerDocInval(newVal) {
            this.formularioValido = newVal
        },
    },
}
</script>

<style>
.cursor-not-allowed {
    cursor: not-allowed;
}

.espacioBotones{
    display: flex;
    justify-content: space-evenly;
}
</style>






